import { Title } from '@kvdbil/components';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { AuctionType } from '~/App/shared/interfaces/Auction';
import { useTranslation } from '~/Locale';
import { LightboxTutorial } from '~/App/views/ObjectPage/components/BuyMethodBox/LightboxTutorial';
import { useObjectPageCMSData } from '../../hooks';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
`;

type Props = {
  buyMethod: AuctionType;
};

function BuyMethodTitle({ buyMethod }: Props) {
  const { t } = useTranslation();

  const isBuyNow = buyMethod === AuctionType.BUY_NOW;

  const { data: cmsData } = useObjectPageCMSData();

  const biddingTutorialLink = cmsData?.buyMethods?.biddingTutorialLink;
  const fixedPriceTutorialLink = cmsData?.buyMethods?.fixedPriceTutorialLink;

  const title = isBuyNow ? t('Car fixed price') : t('Bidding');

  const lightboxTutorialProps = useMemo(
    () => ({
      text: isBuyNow ? t('What is fixed price?') : t('What is bidding?'),
      link: isBuyNow ? fixedPriceTutorialLink : biddingTutorialLink
    }),
    [biddingTutorialLink, fixedPriceTutorialLink, isBuyNow, t]
  );

  return (
    <Container>
      <Title as="span">{title}</Title>

      <LightboxTutorial {...lightboxTutorialProps} />
    </Container>
  );
}

export default BuyMethodTitle;
